import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Colors, Spacing } from '@/shared/theme';
import { Title, Text, VStack } from '@/shared/ui';

// Shown when the pilot gate does not pass for this user (RND-36404).
// Layout mirrors ErrorBoundary's full-screen fallback.
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: ${Spacing.x6}px;
  background-color: ${Colors.background};
  text-align: center;
`;

export const PilotUnavailable: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container role="alert" aria-live="assertive">
      <VStack gap={Spacing.x4}>
        <Title size="h2" centered>
          {t('pilot-gate.unavailable.title')}
        </Title>
        <Text size="p2" centered>
          {t('pilot-gate.unavailable.description')}
        </Text>
      </VStack>
    </Container>
  );
};
